import axios from "axios";

const apiBaseUrl = process.env.REACT_APP_GITO_API_URL;
//const apiBaseUrl = "https://localhost:7241";

const organizationsBaseUrl = `${apiBaseUrl}/Resources/Organizations`;

const countriesBaseUrl = `${apiBaseUrl}/Resources/Countries`;
const paymentMethodBaseUrl = `${apiBaseUrl}/Resources/PaymentMethod`;
const biddingZoneBaseUrl = `${apiBaseUrl}/resources/BiddingZone`;
const thirdPartyBaseUrl = `${apiBaseUrl}/Resources/ThirdPartySystem`;

const authHeaders = (apiAccessToken) => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${apiAccessToken}`,
});

export async function getAllOrganizations(apiAccessToken) {
    try {
        const response = await axios.get(
            `${organizationsBaseUrl}/get-all-organizations`,
            { headers: authHeaders(apiAccessToken) }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch organizations"
        );
    }
}

export async function getOrganizationByPublicId(organizationPublicId, apiAccessToken) {
    try {
        const response = await axios.get(
            `${organizationsBaseUrl}/get-organization/${organizationPublicId}`,
            { headers: authHeaders(apiAccessToken) }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch organization"
        );
    }
}

export async function createOrganization(payload, apiAccessToken) {
    try {
        const response = await axios.post(
            `${organizationsBaseUrl}/create-organization`,
            payload,
            { headers: authHeaders(apiAccessToken) }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to create organization"
        );
    }
}

export async function updateOrganization(payload, apiAccessToken) {
    try {
        const response = await axios.put(
            `${organizationsBaseUrl}/update-organization`,
            payload,
            { headers: authHeaders(apiAccessToken) }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to update organization"
        );
    }
}

export async function deleteOrganization(organizationPublicId, apiAccessToken) {
    try {
        const response = await axios.delete(
            `${organizationsBaseUrl}/delete-organization/${organizationPublicId}`,
            { headers: authHeaders(apiAccessToken) }
        );
        return response.data; // backend returnerar Ok()
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to delete organization"
        );
    }
}

export async function getAllCountries(apiAccessToken) {
    try {
        const response = await axios.get(`${countriesBaseUrl}/get-countries`, {
            headers: authHeaders(apiAccessToken),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to fetch countries");
    }
}

export async function getAllPaymentMethods(apiAccessToken) {
    try {
        const response = await axios.get(
            `${paymentMethodBaseUrl}/get-all-payment-methods`,
            { headers: authHeaders(apiAccessToken) }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch paymentMethods"
        );
    }
}

export async function getAllBiddingZones(apiAccessToken) {
    try {
        const response = await axios.get(
            `${biddingZoneBaseUrl}/get-all-bidding-zones`,
            { headers: authHeaders(apiAccessToken) }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch biddingZones"
        );
    }
}

// Function to get all third-party systems
export async function getAllThirdPartySystems(apiAccessToken) {
    try {
        const response = await axios.get(
            `${thirdPartyBaseUrl}/get-all-third-party-systems`,
            {
                headers: {
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            });
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch third-party systems"
        );
    }
}